import useSWR from "swr";

import { type DocumentVersionDetails } from "../types";
import { simpleFetcher } from "../fetcher";

const url = "/api/v2/document-versions";

export function useDocumentVersion(id: string | number | undefined) {
  return useSWR<DocumentVersionDetails, Error>(
    id ? `${url}/${id}` : null,
    simpleFetcher,
  );
}
